import { React, useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import GlobalContext from "../../providers/GlobalProvider";
import axios from "axios";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/esm/Button";

export default function Accruals() {
  const { defaultMapper } = useContext(GlobalContext);
  const [selectedDb, setSelectedDb] = useState("LibraMapper");
  const [matchesList, setMatchesList] = useState([]);
  const [selectedAccrual, setSelectedAccrual] = useState({});
  const [selectedService, setSelectedService] = useState("");

  const [filteredAccruals, setFilteredAccruals] = useState({
    accNum: [],
    country: [],
  });
  const [filteredServices, setFilteredServices] = useState();

  const [loading, setLoading] = useState(true);
  const BASEURL = "/api/accruals";
  const { dbData, fetchDbData, updateDbData } = useContext(GlobalContext);

  const findService = (arr, accNum) =>
    arr.find((dict) => dict.accNum == accNum);

  const getData = async () => {
    try {
      let response = await axios.get(BASEURL);
      const { service, accruals, accrualsMatches } = response.data;
      setFilteredServices(service);
      setFilteredAccruals(accruals);
      const newMatches = accrualsMatches.map((obj) => {
        return {
          id: obj.id,
          service: {
            accNum: obj.serviceAccNum,
            name: findService(service, obj.serviceAccNum).edescription,
          },
          accruals: {
            accNum: obj.accNum,
            description: obj.country,
          },
        };
      });
      setMatchesList([...matchesList, ...newMatches]);
    } catch (e) {
      console.error("Error fetching data:", e);
      setLoading(false);
    }
  };

  const handleAccNumChange = (event) => {
    const selectedAccNum = event.target.value;
    setSelectedAccrual((prevState) => ({
      ...prevState,
      accNum: selectedAccNum,
    }));
  };
  const handleCountryChange = (event) => {
    const selectedCountry = event.target.value;
    setSelectedAccrual((prevState) => ({
      ...prevState,
      description: selectedCountry,
    }));
  };

  const handleServiceChange = (event) => {
    const serviceSelected = event.target.value;
    console.log("selected service", serviceSelected);
    setSelectedService(serviceSelected);
  };

  const handleDeleteClick = async (id) => {
    try {
      const updatedMatches = matchesList.filter((match) => match.id !== id);
      setMatchesList(updatedMatches);

      await axios.delete(`${BASEURL}/${id}`);
    } catch (e) {
      console.error("Error deleting this match", e);
    }
  };

  const handleSaveClick = async (e) => {
    console.log(selectedAccrual);
    try {
      const newMatch = {
        service: {
          accNum: selectedService,
          name: findService(filteredServices, selectedService).edescription,
        },
        accruals: {
          accNum: selectedAccrual.accNum || "N/A",
          description: selectedAccrual.description || "N/A",
        },
      };

      setMatchesList([...matchesList, newMatch]);

      const matchesData = {
        ServiceAccNum: newMatch.service.accNum,
        AccNum: newMatch.accruals.accNum,
        Country: newMatch.accruals.description,
      };
      await axios.post(BASEURL, matchesData);
    } catch (e) {
      console.error("Error in HandleSaveClick", e);
    }
    setSelectedService("");
    setSelectedAccrual({ accNum: "", description: "" });
  };

  useEffect(() => {
    getData();
  }, [defaultMapper]);

  return (
    <>
      <div className="mapping-container">
        <div>
          <Table hover bordered="false" responsive order>
            <thead>
              <tr>
                <th>Accruals Account Number</th>
                <th>Country</th>
                <th>Service</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {matchesList && matchesList.length > 0 ? (
                matchesList.map((match) => {
                  const accNum = match.accruals.accNum;
                  const countryData = match.accruals.description;
                  const serviceData = match.service.name;
                  return (
                    <tr key={match.id}>
                      <td>{accNum}</td>
                      <td>{countryData}</td>
                      <td>{serviceData}</td>
                      <td>
                        <Button
                          variant="outline-danger"
                          onClick={() => handleDeleteClick(match.id)}
                        >
                          Delete
                        </Button>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="5">No matches found</td>
                </tr>
              )}
              <tr>
                {filteredAccruals && filteredAccruals.length > 0 ? (
                  <>
                    <td>
                      <div>
                        <select
                          className="select-data"
                          onChange={handleAccNumChange}
                          value={
                            selectedAccrual.accNum ? selectedAccrual.accNum : ""
                          }
                        >
                          {!selectedAccrual.accNum && (
                            <option value="">Select an option</option>
                          )}
                          {filteredAccruals.map((item) => (
                            <option key={item.accNum} value={item.accNum}>
                              {item.accNum}
                            </option>
                          ))}
                        </select>
                      </div>
                    </td>
                    <td>
                      <div>
                        <select
                          className="select-data"
                          onChange={handleCountryChange}
                          value={
                            selectedAccrual.description
                              ? selectedAccrual.description
                              : ""
                          }
                        >
                          {!selectedAccrual.description && (
                            <option value="">Select an option</option>
                          )}
                          {filteredAccruals.map((item) => (
                            <option
                              key={item.description}
                              value={item.description}
                            >
                              {item.description}
                            </option>
                          ))}
                        </select>
                      </div>
                    </td>
                  </>
                ) : (
                  <td colSpan="2">No data</td>
                )}
                <td>
                  <div>
                    {filteredServices && filteredServices.length > 0 ? (
                      <select
                        onChange={handleServiceChange}
                        value={selectedService ? selectedService : ""}
                      >
                        {!selectedService && (
                          <option value="">Select an option</option>
                        )}
                        {filteredServices.map((item) => (
                          <option key={item.accNum} value={item.accNum}>
                            {item.description}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <p>No Data</p>
                    )}
                  </div>
                </td>
                <td></td>
              </tr>
            </tbody>
          </Table>
          <Link to="/">
            <Button variant="outline-danger">Main Menu</Button>
          </Link>
          <Button
            onClick={handleSaveClick}
            // disabled={disabled}
            variant="outline-success"
          >
            Save
          </Button>
        </div>
      </div>
    </>
  );
}
